import { jsx as i, jsxs as E } from "react/jsx-runtime";
import { forwardRef as M, useState as S, useRef as _, useMemo as z, useCallback as V, useId as U, cloneElement as he, useEffect as H } from "react";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { R as W } from "./rectangle-button-DWXg4KwQ.mjs";
import { I as ge } from "./ic_close-C57k_mIW.mjs";
import { t as Ce } from "./throttle-CbOTDqvg.mjs";
import { o as ve } from "./index-CcECYkhV.mjs";
import { I as we } from "./icon-button-CBGiAhhG.mjs";
import { c as f } from "./variance-DhhqoHkK.mjs";
import { u as O } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { createPortal as be } from "react-dom";
const xe = f(["w-screen h-screen fixed left-0 top-0 bg-scrim"], {
  variants: {
    show: {
      true: "animate-dimFadeIn",
      false: "animate-dimFadeOut"
    }
  }
}), X = M(
  ({ show: a = !0, zMax: t, onClick: m = () => {
  }, onAnimationEnd: o = () => {
  }, children: n }, e) => {
    const [l, g] = S(!1), p = xe({
      show: a
    });
    return O(() => {
      g(!1);
    }, [a]), !a && l ? null : (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- dim layer click
      /* @__PURE__ */ i(
        "div",
        {
          className: s(p, t ? "z-max" : ""),
          onAnimationEnd: () => {
            g(!0), o();
          },
          onClick: m,
          ref: e,
          children: n
        }
      )
    );
  }
);
X.displayName = "NDS.DimLayer";
const Se = ({ show: a, mode: t }) => {
  O(() => {
    if (!a) return;
    window.ya__ || (window.ya__ = { dialogCount: 0 });
    const m = window.ya__.dialogCount ?? 0;
    if (window.ya__.dialogCount = m + 1, t === "fixed") {
      const [o, n, e] = [document.body.style.position, window.scrollY, window.scrollX];
      return document.body.style.position = "fixed", document.body.style.top = `-${n}px`, document.body.style.left = `-${e}px`, () => {
        window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.position = o, window.scroll({ top: n, left: e }));
      };
    }
    return document.body.style.overflow = "hidden", () => {
      window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.overflow = "unset");
    };
  }, [t, a]);
}, q = "_ROOT_NDS_MODAL_", _e = ({ id: a, children: t, show: m, zIndex: o = 1, containerClassName: n = "" }) => {
  const e = _(null), [l, g] = S(null), p = z(() => l ? be(t, l) : null, [t, l]), v = V(() => {
    var c;
    (c = l == null ? void 0 : l.parentElement) == null || c.removeChild(l);
  }, [l]), y = V(() => {
    e.current = document.getElementById(q), e.current || (e.current = document.createElement("div"), e.current.id = q, e.current.style.position = "relative", e.current.style.zIndex = `${o}`, n && (e.current.className = n), document.body.appendChild(e.current));
    const c = `modal-${a}`;
    let r = document.getElementById(c);
    return r || (r = document.createElement("div"), r.id = c, e.current.appendChild(r)), r;
  }, [a]);
  return O(() => {
    if (!m) return;
    const c = y(), r = document.createElement("div");
    return g(r), c.appendChild(r), () => {
      r.addEventListener("animationend", () => {
        var w, b;
        (w = r.parentElement) == null || w.removeChild(r), (b = c.parentElement) == null || b.removeChild(c);
      });
    };
  }, [m, y]), {
    portal: p,
    modalElement: l,
    clearModalElement: v
  };
}, B = (a) => {
  const t = U(), { id: m, mode: o = "overflow", show: n = !0, zIndex: e, containerClassName: l, children: g } = a, p = z(() => m ?? t, [m, t]);
  Se({ show: n, mode: o });
  const v = g ? he(g, {
    id: p,
    mode: o
  }) : null, { portal: y, clearModalElement: c } = _e({
    id: p,
    show: n,
    zIndex: e,
    containerClassName: l,
    children: /* @__PURE__ */ i(
      X,
      {
        id: p,
        mode: o,
        onAnimationEnd: () => {
          !n && c();
        },
        onClick: a.onBackdropClick,
        show: n,
        children: v ?? void 0
      }
    )
  });
  return y;
};
B.displayName = "NDS.Modal";
const Y = f([
  "fixed mx-auto left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-h-screen min-h-88"
]), Ne = f(
  ["inline-flex flex-col align-center justify-center bg-static-white rounded-28"],
  {
    variants: {
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      },
      size: {
        medium: "w-[29.6rem] pt-24 px-20 pb-20",
        large: "w-[40rem] pt-32 px-24 pb-24"
      }
    },
    defaultVariants: {
      size: "medium"
    }
  }
), Ee = f(["inline-flex flex-col"]), De = f(["text-text-neutral-main select-none whitespace-pre-line"], {
  variants: {
    size: {
      medium: "typography-subtitle-16-bold-multiline",
      large: "typography-subtitle-20-bold-multiline"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), Ie = f(["inline-flex flex-col"]), ze = f(["mt-12 text-text-neutral-sub select-none whitespace-pre-line break-words"], {
  variants: {
    size: {
      medium: "typography-body-14-regular-multiline",
      large: "typography-subtitle-16-regular-multiline"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), He = f(
  ["inline-flex typography-body-14-bold  items-stretch justify-center gap-8 mt-24"],
  {
    variants: {
      buttonDirection: {
        horizontal: "flex-row",
        vertical: "flex-col-reverse w-full"
      }
    }
  }
), Te = M(
  ({
    id: a,
    show: t,
    title: m,
    description: o,
    positiveButton: n,
    negativeButton: e,
    zIndex: l,
    onAnimationEnd: g,
    mode: p,
    onBackdropClick: v,
    containerClassName: y,
    buttonDirection: c = "horizontal",
    size: r = "medium"
  }, w) => {
    const b = Y({}), T = Ne({ active: t, size: r }), R = Ee({}), k = De({ size: r }), P = Ie({}), A = ze({ size: r }), N = He({ buttonDirection: c }), D = _(null), I = _(null);
    H(() => {
      let u;
      return t && (I.current = document.activeElement, u = requestAnimationFrame(() => {
        var d;
        (d = D.current) == null || d.focus();
      })), () => {
        var d;
        u && cancelAnimationFrame(u), t || (d = I.current) == null || d.focus();
      };
    }, [t]), H(() => {
      var u;
      return t && ((u = document.getElementById("__next")) == null || u.setAttribute("aria-hidden", "true")), () => {
        var d;
        (d = document.getElementById("__next")) == null || d.removeAttribute("aria-hidden");
      };
    }, [t]);
    const C = ({ title: u, text: d }) => u ?? (typeof d == "string" ? d : void 0);
    return /* @__PURE__ */ i(
      B,
      {
        containerClassName: y,
        id: a,
        mode: p,
        onBackdropClick: v,
        show: t,
        zIndex: l,
        children: /* @__PURE__ */ i(
          "div",
          {
            className: s(b),
            onClick: (u) => {
              u.stopPropagation();
            },
            ref: w,
            children: /* @__PURE__ */ E("div", { className: s(T), onAnimationEnd: g, children: [
              /* @__PURE__ */ i("div", { className: s(R), children: /* @__PURE__ */ i("span", { className: s(k), style: { overflowWrap: "anywhere" }, children: m }) }),
              !!o && /* @__PURE__ */ i("div", { className: s(P), children: /* @__PURE__ */ i("span", { className: s(A), children: o }) }),
              /* @__PURE__ */ E("div", { className: s(N), children: [
                !!e && /* @__PURE__ */ i(
                  W,
                  {
                    fullWidth: !0,
                    onClick: e.onClick,
                    size: "medium",
                    theme: e.theme ?? "outlined_basic",
                    title: C(e),
                    weight: "bold",
                    children: e.text
                  }
                ),
                /* @__PURE__ */ i(
                  W,
                  {
                    fullWidth: !0,
                    onClick: n.onClick,
                    ref: D,
                    size: "medium",
                    theme: n.theme ?? "filled_primary",
                    title: C(n),
                    weight: "bold",
                    children: n.text
                  }
                )
              ] })
            ] })
          }
        )
      }
    );
  }
);
Te.displayName = "NDS.Dialog";
const Re = f(
  ["inline-flex overflow-auto flex-col bg-static-white rounded-28 py-24 shadow-3"],
  {
    variants: {
      size: {
        medium: "w-[40rem]",
        large: "w-[60rem]"
      },
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      }
    }
  }
), ke = f([
  "pl-32 pr-20 pb-4 flex items-start justify-between gap-16 self-stretch"
]), Pe = f(["my-8 text-text-neutral-main select-none"], {
  variants: {
    titleType: {
      action: "typography-subtitle-20-bold truncate",
      highlight: "typography-subtitle-20-bold-multiline line-clamp-2",
      noPadding: ""
    }
  },
  defaultVariants: {
    titleType: "action"
  }
}), Ae = f(["flex items-center justify-center size-40 p-4 cursor-pointer"]), Fe = f("overflow-auto relative h-full", {
  variants: {
    bodyType: {
      default: "px-32",
      noPadding: ""
    }
  }
}), Le = f("w-full shrink-0", {
  variants: {
    footerType: {
      default: "px-32 pt-12",
      noPadding: ""
    }
  }
}), Me = 48, Oe = M((a, t) => {
  var $, G;
  const {
    id: m,
    show: o,
    title: n,
    titleType: e = "action",
    body: l,
    bodyType: g = "default",
    footer: p,
    footerType: v = "default",
    height: y = "contents",
    noCloseIcon: c = !1,
    className: r,
    containerClassName: w,
    onAnimationEnd: b,
    onClose: T,
    mode: R,
    zIndex: k,
    bottomSheetBodyRef: P,
    size: A = "medium",
    onScroll: N,
    hasBottomGradation: D = !0,
    onBackdropClick: I
  } = a, C = _(null), u = _(null), d = _(null), j = U(), [K, Q] = S(!1), [Z, ee] = S(!1), [te, ne] = S(0), [oe, ie] = S(0), ae = z(() => m ?? j, [m, j]), le = Y(), re = Re({
    active: o,
    size: A
  }), se = ke(), ce = Ae(), de = Pe({ titleType: e }), me = Fe({ bodyType: g }), ue = Le({ footerType: v }), fe = z(() => y === "contents" ? "auto" : y === "full" ? "100%" : y, [y]), F = Ce(() => {
    if (C.current) {
      const { scrollTop: h, scrollHeight: x, clientHeight: L } = C.current, ye = h + L >= x - 1;
      ee(!ye);
    }
  }, 100), pe = (h) => {
    F(), N == null || N(h);
  };
  return H(() => {
    const h = () => {
      if (C.current) {
        const { scrollHeight: x, clientHeight: L } = C.current;
        Q(x > L);
      }
    };
    if (o)
      return F(), h(), window.addEventListener("resize", h), () => {
        window.removeEventListener("resize", h);
      };
  }, [o, C.current, y]), H(() => {
    var h, x;
    o && (F(), ie(((h = d.current) == null ? void 0 : h.clientHeight) ?? 0), ne(((x = u.current) == null ? void 0 : x.clientHeight) ?? 0));
  }, [o, ($ = d.current) == null ? void 0 : $.clientHeight, (G = u.current) == null ? void 0 : G.clientHeight]), /* @__PURE__ */ i(
    B,
    {
      containerClassName: w,
      id: ae,
      mode: R,
      onBackdropClick: I,
      show: o,
      zIndex: k,
      children: /* @__PURE__ */ i(
        "div",
        {
          className: s(le, "flex"),
          onClick: (h) => {
            h.stopPropagation();
          },
          ref: t,
          style: {
            maxHeight: "calc(100vh - 200px)",
            height: fe,
            minHeight: `${oe + te + Me}px`
          },
          children: /* @__PURE__ */ E("div", { className: s(re, r), onAnimationEnd: b, children: [
            /* @__PURE__ */ i("div", { ref: d, children: e === "noPadding" ? n : /* @__PURE__ */ E("div", { className: s(se), children: [
              /* @__PURE__ */ i("span", { className: s(de), children: n }),
              !c && /* @__PURE__ */ i(
                we,
                {
                  "aria-label": "닫기",
                  className: s(ce),
                  icon: /* @__PURE__ */ i(ge, { className: "size-24" }),
                  onClick: T,
                  size: "medium",
                  theme: "ghost"
                }
              )
            ] }) }),
            !!l && /* @__PURE__ */ E("div", { className: "relative h-full overflow-y-auto", children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: s(me),
                  onScroll: pe,
                  ref: ve([C, P]),
                  children: l
                }
              ),
              K && D ? /* @__PURE__ */ i(
                "div",
                {
                  className: s(
                    "pointer-events-none absolute inset-x-0 bottom-0 z-50 h-80 px-32 opacity-0 transition-opacity duration-500",
                    {
                      "opacity-100": Z
                    }
                  ),
                  style: {
                    background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 82.36%)"
                  }
                }
              ) : null
            ] }),
            !!p && /* @__PURE__ */ i("div", { className: s(ue), ref: u, children: p })
          ] })
        }
      )
    }
  );
});
Oe.displayName = "NDS.PcDialogSheet";
let J;
const Ke = (a) => {
  J = a;
}, Qe = () => J;
export {
  X as D,
  Oe as P,
  Te as a,
  Qe as g,
  Ke as s,
  Se as u
};
